/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';

import useStyles from './styles';

const ButtonAnswer = ({
  children,
  description,
  image,
  icon: Icon,
  isChecked,
  keylineVariant = 1,
  isGender,
  isSelected,
  ...rest
}) => {
  const styles = useStyles();
  const hasDescription = !!description;

  return (
    <button
      css={styles.btn({ keylineVariant, hasDescription, isGender, isChecked })}
      {...rest}
      role='option'
      aria-selected={isSelected}
    >
      <span>
        {children}
      </span>
      {description && <span css={styles.description}>{description}</span>}
      {// in new design we are not using images but need to confirm
      /* {image && (
        <img
          width={hasDescription ? '33%' : '30%'}
          css={styles.image}
          alt=""
          src={image}
        />
      )} */}
    </button>
  );
};

ButtonAnswer.propTypes = {
  children: PropTypes.any,
  description: PropTypes.string,
  image: PropTypes.any,
  icon: PropTypes.any,
  isChecked: PropTypes.any,
  isGender: PropTypes.any,
  keylineVariant: PropTypes.any,
};

export default ButtonAnswer;
